<template>
  <div>
    <header>
      <div class="ef--inner first">
        <h1>
          <img src="/assets/images/common/logo.png" alt="きゅうでん電気予報">
        </h1>
        <div class="admin">
          <span>{{username}}さま</span>
          <a href="javascript:void(0);" @click="onLogout()">ログアウト</a>
        </div>
      </div>
      <nav>
        <div class="ef--inner">
          <div class="nav-area">
            <ul>

              <!-- 電衛門のみ
              <li>
                <a href="javascript:void(0);" @click="$router.push('/shop')">
                  <img src="/assets/images/common/menu.icon1.png">
                  <span>事業所一覧</span>
                </a>
              </li>
              <li>
                <a href="javascript:void(0);" @click="$router.push('/shop/shop_comparison')">
                  <img src="/assets/images/common/admin_menu.icon2.png">
                  <span>事業所比較</span>
                </a>
              </li>
              <li>
                <a href="javascript:void(0);" @click="$router.push('/shop/send_mail')">
                  <img src="/assets/images/common/admin_menu.icon3.png">
                  <span>メール一斉送信</span>
                </a>
              </li>
              <li>
                <a href="javascript:void(0);" @click="$router.push('/shop/shop_control')">
                  <img src="/assets/images/common/admin_menu.icon3.png">
                  <span>事業所管理</span>
                </a>
              </li>
              <li class="li-bottom">
                <a href="javascript:void(0);" @click="$router.push('/shop/shop_aggregation')">
                  <img src="/assets/images/common/menu.icon8.png">
                  <span>需給状況グラフ</span>
                </a>
              </li>
              -->

              <li class="li-bottom">
                <a href="javascript:void(0);" @click="$router.push('/shop/multi_circuit_graph_list')">
                  <img src="/assets/images/common/menu.icon7.png">
                  <span>グラフ</span>
                </a>
              </li>

              <li class="li-bottom">
                <a href="javascript:void(0);" @click="downloadDialog = true">
                  <img src="/assets/images/common/admin_menu.icon3.png">
                  <span>CSV出力</span>
                </a>
              </li>
            </ul>

          </div>
          <div class="panel">
            <div class="menu-trigger">
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
        </div>
      </nav>
    </header>
    <router-view/>
    <footer>
      <div class="ef--inner">
        <p>Copyright (c) KYUSHU ELECTRIC POWER CO., INC. All Rights Reserved.</p>
      </div>
    </footer>

    <download-dialog
      @close="downloadDialog=false"
      v-if="downloadDialog"
      :account="this.$store.state.loginID"
    ></download-dialog>

  </div>
</template>

<script>
import DownloadDialog from "../TakairoCsvDownloadDialog";

export default {
  name: "admin",
  components: {
    DownloadDialog
  },
  data: function() {
    return {
      downloadDialog: false
    }
  },
  computed: {
    username() {
      return this.$store.state.parentID;
    }
  },
  mounted: function() {
    /* sp panel */
    $(".panel").on("click", function() {
      // console.log('admin:panel_click');
      
      $(".menu-trigger, header nav").toggleClass("active");
      $("nav .nav-area").slideToggle();
      $(".overlay").fadeToggle("slow");
    });
    $(".overlay").on("click", function() {
      $(".overlay, nav .nav-area").fadeToggle("slow");
      $(".menu-trigger, header nav").removeClass("active");
    });
  },
  methods: {
    /* eslint-disable no-console */
    /* eslint-disable no-unused-vars */
    onLogout: function() {
      console.log("logout");
      const self = this;
      const params = new URLSearchParams();
      this.$store.dispatch("logout");
      this.$store.commit("RESET");
      this.$axios
        .post(`/srv/api/logout`, params, {
          withCredentials: true
        })
        .then(response => {
          const data = response.data;
          // console.log(data);
          if (data.status !== undefined) {
            if (data.status === "success") {
              console.log("success");
              self.$router.push("/login");
            } else {
              console.log("error");
              self.$router.push("/login");
            }
          } else {
            console.log("error");
            self.$router.push("/login");
          }
        })
        .catch(error => {
          console.log(error);
        });
    }
  }
};
</script>

<style>
/* body {
  font-size: 14px;
  font-size: 1.0rem;
  font-weight: 500;
  line-height: 1.6;
  position: relative;
  -webkit-text-size-adjust: 100%;
  -moz-text-size-adjust: 100%;
  -ms-text-size-adjust: 100%;
  -o-text-size-adjust: 100%;
  text-size-adjust: 100%;
  text-align: left;
  width: 100%;
  color: #4e4d4d;
} */
</style>
